<script setup lang="ts">
import LoadingSpinner from './LoadingSpinner.vue'
</script>

<template>
  <div class="flex h-full w-full items-center justify-center">
    <div class="flex flex-col items-center gap-y-4 p-8 text-gray-400">
      <LoadingSpinner />
    </div>
  </div>
</template>
